import HeroPage from '../components/HeroPage'
import StoreBadges from '../components/StoreBadges'

// Where a /app/* link lands when nothing opened the app.
//
// On a phone with Padelr installed the link never reaches the web at all - iOS
// and Android claim it and open the screen directly. This page is for the rest:
// a laptop, or a phone without the app, which is where a good share of email is
// read. Saying "install the app" is more use than a homepage the reader has to
// find their own way out of.
const APP_STORE_URL = "https://apps.apple.com/fr/app/padelr/id6657992480"
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.padel.day.padelr"

// What each destination is called, so the page can name the thing the reader
// was actually trying to reach. Keyed by the view segment the emails and the
// push payloads both use.
const DESTINATIONS = {
    wannaplay: "vos disponibilités",
    communities: "les disponibilités de votre communauté",
    games: "vos parties",
    tournaments: "vos tournois",
    // A lesson reminder email, or a créneau scanned from a coach's page on
    // padelr.app/coach.
    lessons: "ce cours",
}

function destinationName() {
    const view = window.location.pathname.split("/").filter(Boolean)[1]
    return DESTINATIONS[view] || "cette page"
}

export function AppLinkView() {
    return (
        <HeroPage
            heading={`Ouvrez ${destinationName()} dans l'application Padelr`}
            supporting="Ce lien ouvre directement l'application sur votre téléphone. Installez-la, puis rouvrez le lien depuis votre email."
        >
            <StoreBadges appStoreURL={APP_STORE_URL} playStoreURL={PLAY_STORE_URL} />
        </HeroPage>
    )
}

export default AppLinkView
